$(() => {
    // Copy paste from example in documentation
    // See https://jqueryui.com/autocomplete/#categories
    $.widget('custom.autocompleteAgency', $.ui.autocomplete, {
        _create() {
            this._super();
            this.widget().menu('option', 'items', '> :not(.js-searchAutocomplete__menuCategory)');
        },
        _renderMenu(ul, items) {
            let currentCategory = '';
            ul.addClass('M-searchAutocomplete__menu');
            $.each(items, (index, item) => {
                if (item.category !== currentCategory && item.category !== 'message') {
                    ul.append(`<li class='M-searchAutocomplete__menuCategory js-searchAutocomplete__menuCategory'>${item.category}</li>`);
                    currentCategory = item.category;
                }
                const li = this._renderItemData(ul, item);
                if (item.category) {
                    li.attr('aria-label', `${item.category} : ${item.label}`);
                }
            });
        },
        _renderItem(ul, item) {
            if (item.category === 'message') {
                return $('<li class="M-searchAutocomplete__menuMessage js-searchAutocomplete__menuCategory">').html(item.labelHtml).appendTo(ul);
            }
            return $('<li class="M-searchAutocomplete__menuItem">').html(item.labelHtml).appendTo(ul);
        },
    });


    class AgencyAutocomplete {
        constructor($wrapper, options) {
            const defaults = {
                inputSelector: '.js-textField__formElement',
                btnClearSelector: '.js-textField__searchReset',
                filledClass: '-filled',
            };

            this.options = $.extend(defaults, options);
            this.wrapper = $wrapper;
            this.input = $wrapper.find(this.options.inputSelector);
            this.btnClear = $wrapper.find(this.options.btnClearSelector);
            this.searchUrl = this.wrapper.attr('data-autocomplete-search-url');
            this.resultsUrl = this.wrapper.attr('data-autocomplete-results-url');

            this.btnClear.on('click', () => {
                this.clearAutocomplete();
            });

            this.input.autocompleteAgency({
                minLength: 3,
                source: (request, response) => {
                    // Load new suggestions
                    this.loadSuggestions(request.term).then((data) => {
                        response(data); // Update jquery autocomplete
                    });
                },
                select: (event, ui) => {
                    const data = ui.item.data;
                    this.wrapper.data('selected-item', data);
                    this.selectSuggestion(data);
                },
                position: {
                    my: 'left+0 top+2',
                },
            });
        }

        /**
         * Loads new suggestions from API
         * @param text Search phrase
         * @return Promise
         */
        loadSuggestions(text) {
            return $.nette.ajax({
                type: 'GET',
                url: this.searchUrl,
                data: {
                    q: text, // Pass string from search input
                },
            }).then((payload, status, jqXHR) => {
                if (payload.status.code !== 1) {
                    Bingo.AjaxFailed.showError(payload.status.message);
                    return $.Deferred().reject(jqXHR); // Reject promise
                }

                return payload.data;
            }).then((suggestions) => {
                let data = [];

                // Transform API response to data for autocomplete [{label, category, data}]
                for (const category in suggestions) {
                    if (category === 'message') {
                        data = data.concat([{
                            label: suggestions[category],
                            labelHtml: suggestions[category],
                            category,
                        }]);
                    } else {
                        data = data.concat(suggestions[category].map(
                            suggestion => ({
                                label: suggestion.name,
                                labelHtml: AgencyAutocomplete.highlightSearchText(suggestion.name, text),
                                category,
                                data: suggestion,
                            }),
                        ));
                    }
                }

                return data;
            });
        }

        /**
         * Refresh agency list snippet with new search results
         * @param data
         */
        selectSuggestion(data) {
            this.disable();
            // find all dropdown filters and set their values to null without sending a server request for their onChange events
            $('select.js__filter-select').each(function () {
                $(this).data('filter-send-request', 'false');
                $(this)[0].selectize.setValue(null);
                $(this).data('filter-send-request', 'true');
            });
            $.nette.ajax({
                type: 'GET',
                url: this.resultsUrl,
                data: {
                    agencies: data.results,
                },
            });
        }

        /**
         * Clear autocomplete and refresh list of agencies
         */
        clearAutocomplete() {
            this.clear();
            $.nette.ajax({
                type: 'GET',
                url: this.resultsUrl,
            });
        }

        /**
         * Disable search input
         */
        disable() {
            this.input.prop('disabled', true);
            this.input.closest('.A-textField').addClass(this.options.filledClass);
        }

        /**
         * Clear search input
         */
        clear() {
            this.input.val('');
            this.input.prop('disabled', false);
            this.input.trigger('change');
            this.input.focus();
            this.input.closest('.A-textField').removeClass(this.options.filledClass);
            this.wrapper.data('selected-item', null);
        }

        /**
         * Returns html string with search text wrapped in <strong>
         * @param suggestion
         * @param searchText
         * @return string
         */
        static highlightSearchText(suggestion, searchText) {
            return suggestion.replace(new RegExp(`(${searchText})`, 'ig'), '<strong>$1</strong>');
        }
    }

    new AgencyAutocomplete($('.js-searchAutocomplete--agencies'));
});
